<template>
  <v-container fluid>
    <v-row class="my-12">
      <v-col class="text-center">
        <PageTitle :title="label('description1')"/>
        <PageTitle :title="label('description2')"/>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="text-center">
        <ActionButton type="link" @click="go('/clients/jobs')" width="300px">
          {{label("back")}}
        </ActionButton>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import PageTitle from "../../atoms/PageTitle";
  import ActionButton from "../../molecules/ActionButton";
  import ComponentMixin from "../../ComponentMixin";

  export default {
    mixins: [ComponentMixin],
    type: "page",
    name: "ClientRegisterCompletedPage",
    components: {
      PageTitle,
      ActionButton
    }
  }
</script>

<style scoped lang="sass">

</style>
